import { default as ReactSelect, components } from "react-select";
const Option = (props: any) => {
 
  const isFirstItem = (title:string)=>{
     for(let item of props.options){
        if(item?.groupKey === props?.data?.groupKey){
       return item?.id === props?.data?.id
    }
     }
  return false
  }
 
  return (
    <div>
      {props?.data?.groupKey && isFirstItem(props?.data?.groupKey) && <h3 className="p-2 border-b border-dashed border-[#ccc] bg-[#f3f3f3]">{props?.data?.groupTitle}</h3>}
      <components.Option {...props}>
        <input
          className=" accent-primary dark:accent-primaryYellow"
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

export default Option;
